import { Variant } from "react-bootstrap/esm/types";
import styles from "./pulsePoint.module.scss";

type Props = {
  variant: Variant;
};

const PulsePoint = ({ variant }: Props) => (
  <svg
    className={`${styles[variant as string]}`}
    x="0px"
    y="0px"
    width="50px"
    height="50px"
    viewBox="0 0 70 70"
  >
    <circle className={styles.pulseDisk} cx="35" cy="35" />
    <circle className={styles.pulseCircle} cx="35" cy="35" strokeWidth="2" />
    <circle
      className={styles.pulseCircleSecond}
      cx="35"
      cy="35"
      strokeWidth="2"
    />
  </svg>
);

export default PulsePoint;
